export default function splitStringByLength(str, maxLength = 50) {
  const words = str.split(' ');
  const result = [];
  let currentLine = '';

  words.forEach(word => {
    if ((currentLine + word).length <= maxLength) {
      currentLine += (currentLine === '' ? '' : ' ') + word;
    } else {
      result.push(currentLine);
      currentLine = word;
    }
  });

  if (currentLine.length > 0) {
    result.push(currentLine);
  }

  return result.join('<br>');
}
